
<app-display-projects-chart-view [allProjectsSetter]="projectsToDisplay" *ngIf="isDataAvailable">
</app-display-projects-chart-view>



<div class="fix" style="min-height: 200rem;"></div>
